<template>
  <div class="px-4 py-2 bg-white rounded">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="w-6"
      viewBox="0 0 270.268 344.593"
    >
      <g
        id="Group_27"
        data-name="Group 27"
        transform="translate(-794.53 -48.229)"
      >
        <path
          id="Path_98"
          data-name="Path 98"
          d="M1247.936,226.2l38.8,37.845L1389.245,177.9h0l-104.492,131-59.915-59.377Z"
          transform="translate(-347.602 83.926)"
          fill="#d63943"
        />
        <path
          id="Path_99"
          data-name="Path 99"
          d="M1340.381,164.97l-15.208-14.659V124.584h-19.43l0,7-20.013-19.29-38.585,37.787h0l-15.208,14.894h15.208v45.638h26.444V179.113h25.123v31.494h26.466V164.97Z"
          transform="translate(-342.165 33.634)"
          fill="#d63943"
        />
        <path
          id="Path_100"
          data-name="Path 100"
          d="M1448.275,194.893c.949-80.744-47.393-137.906-126.685-137.906a143.569,143.569,0,0,0-90.607,254.937l22.8-23.311a110.819,110.819,0,0,1-42.562-87.4c0-2.577.1-5.13.268-7.663,3.09-64.232,49.727-110.162,118.087-110.162,70.417,0,119.359,60.423,109.876,161.15A148.223,148.223,0,0,0,1448.275,194.893Z"
          transform="translate(-383.491 -8.758)"
          fill="#0a0143"
        />
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
